import { Component, OnInit } from '@angular/core';
import { MeetingService } from '../../services/meeting.service';
import { Router } from '@angular/router';
import { EmailValidator } from '../validators/email_validator';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'angular2-cookie/services/cookies.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  busy: Promise<any>;
  f_name: any;
  l_name: any;
  email: any;
  c_email: any;
  pass: any;
  pass2: any;
  c_name: any;
  phone: any;
  error: any;
  regform: FormGroup;
  submitAttempt: boolean;
  code: any = '';
  ref: any = '';

  constructor(
    public meetingService: MeetingService,
    private _cookieService: CookieService,
    public router: Router,
    public formBuilder: FormBuilder,
    public route: ActivatedRoute) {

    const regexExpression = `^[a-zA-Z{L}\\s\\'.-]+$`;
    const nameMatchRegex = new RegExp(regexExpression);

    this.regform = formBuilder.group({
        f_name: ['', Validators.compose([Validators.maxLength(30), Validators.pattern( nameMatchRegex ), Validators.required])],
        l_name: ['', Validators.compose([Validators.maxLength(30), Validators.pattern( nameMatchRegex ), Validators.required])],
        email: ['', Validators.compose([Validators.required, EmailValidator.isValid])],
        c_email: ['', Validators.required],
        c_name: ['', Validators.required],
        pass: ['', Validators.compose([Validators.required])],
        pass2: ['', Validators.required],
        phone: ['', Validators.required]
      },
      {validator: this.matchingPasswords('pass', 'pass2', 'email', 'c_email')});

  }

  matchingPasswords(passwordKey: string, confirmPasswordKey: string, email: string, confirmemail: string) {
      return (group: FormGroup): {[key: string]: any} => {
        const password = group.controls[passwordKey];
        const confirmPassword = group.controls[confirmPasswordKey];
        const emailadd = group.controls[email];
        const confirmemailadd = group.controls[confirmemail];

        if (password.value !== confirmPassword.value) {
          return {
            mismatchedPasswords: true
          };
        }
        if (emailadd.value !== confirmemailadd.value) {
          return {
            mismatchedEmail: true
          };
        }
      };
    }

  ngOnInit() {
    const code = this.route.snapshot.queryParams['c'];
    if (code) {
      this.code = code;
      // console.log(this.code);
    } else {
      this.code = '';
      // console.log(this.code);
    }
    const url_name = this.route.snapshot.queryParams['r'];
    if (url_name) {
      this.ref = url_name;
      // console.log(this.ref);
    } else {
      this.ref = '';
      // console.log(this.ref);
    }
    const city1 = this.route.snapshot.queryParams['city'];
    if (city1) {
      this._cookieService.put('reg_city_id', city1);
      // console.log(this.ref);
    }
    const city2 = this.route.snapshot.queryParams['cityid'];
    if (city2) {
      this._cookieService.put('reg_city_id', city2);
      // console.log(this.ref);
    }

  }

  getRegister() {
      this.submitAttempt = true;

      let def_city;

      if (!this.regform.valid) {
          // console.log("not valid");
      } else {
        if (this._cookieService.get('reg_city_id')) {
          def_city = this._cookieService.get('reg_city_id');
        } else {
          def_city = '0';
        }
      // console.log(this.f_name);
      // console.log(this.l_name);
      // console.log(this.email);
      // console.log(this.pass);
      this.busy = this.meetingService
      .getRegister(this.f_name, this.l_name, this.email, this.pass, this.phone, this.c_name, this.code, this.ref, def_city)
      .subscribe(response => {
        if (response) {
          if (response.success === 1) {
            // console.log(response);
            const success_msg = response.message;
            // console.log(success_msg);
            this._cookieService.remove('reg_city_id');
            this._cookieService.put('msg', success_msg);
            // window.location.href = "http://ovo.dev.bluelightit.com/?message=Success.%20Please%20login";
            const link = ['/login'];
            this.router.navigate(link);
          } else {
            this.error = response.message;
            window.scrollTo(0, 0);
          }

        } else {
          // console.log("error");
        }
      });
    }
  }

}
